import React from 'react';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { PRIMARY_COLOR } from '../constants';

type AreaTitleProps = {
  number: string,
  area: string,
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  sectionNumber: {
    backgroundColor: PRIMARY_COLOR,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 40,
    height: 40,
    borderRadius: '50%',
    color: 'white',
    fontWeight: 'bold',
    fontSize: 16,
  },
  sectionTitle: {
    marginLeft: theme.spacing(1),
    fontWeight: 'bold',
    fontSize: 20,
    [theme.breakpoints.up('sm')]: {
      fontSize: 24,
    },
  },
}));

const AreaTitle = ({ number, area }: AreaTitleProps) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.sectionNumber}>{number}</div>
      <Typography className={classes.sectionTitle}>{area}</Typography>
    </div>
  );
};

export default AreaTitle;
